import { initGame } from './game';

// Initialize the game when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
  
  if (!canvas) {
    console.error('Canvas element not found');
    return;
  }
  
  try {
    // Initialize the game with AI-first architecture
    initGame(canvas);
    console.log('🚀 Pixel Ascent Modern loaded successfully');
    console.log('🔍 Open DevTools to see AI extension points');
    console.log('📁 All game logic is in src/game.ts for AI visibility');
  } catch (error) {
    console.error('Failed to initialize game:', error);
    
    // Display error message to user
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#ff0000';
      ctx.font = '16px monospace';
      ctx.fillText('Game initialization failed', 10, 30);
      ctx.fillText('Check console for details', 10, 50);
    }
  }
});

// Prevent right-click context menu on canvas
const gameCanvas = document.getElementById('gameCanvas');
if (gameCanvas) {
  gameCanvas.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });
}

// Prevent scrolling when using arrow keys
window.addEventListener('keydown', (e) => {
  if (['Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.code) > -1) {
    e.preventDefault();
  }
}, false);

// Game loaded successfully
console.log('%c🎮 PIXEL ASCENT', 'color: #00ff00; font-size: 16px; font-weight: bold;');
console.log('Game loaded successfully!'); 